import React, { useEffect } from "react";
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { api } from "common";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";
import { Outlet } from "react-router-dom";

function PublicLoading() {
  const { t } = useTranslation();
  const {
    fetchSettings,
    fetchLanguages,
  } = api;
  const dispatch = useDispatch();
  const languagedata = useSelector((state) => state.languagedata);
  const settingsdata = useSelector((state) => state.settingsdata);

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch, fetchSettings]);

  useEffect(() => {
    if (settingsdata.settings) {
      dispatch(fetchLanguages());
      document.title = settingsdata.settings.appName;
    }
  }, [settingsdata.settings, dispatch, fetchLanguages]);

  useEffect(() => {
    if (languagedata.langlist) {
      for (const value of Object.values(languagedata.langlist)) {
        if (value.default === true) {
          i18n.addResourceBundle(
            value.langLocale,
            "translations",
            value.keyValuePairs
          );
          i18n.changeLanguage(value.langLocale);
          moment.locale(value.dateLocale);
        }
      }
    }
  }, [languagedata.langlist]);

  return settingsdata.loading ? (
    <CircularLoading />
  ) : settingsdata.settings ? (
    languagedata.loading || !languagedata.langlist ? (
      <CircularLoading />
    ) : (
      <Outlet />
    )
  ) : (
    <div>
      <span>{t("no_database_settings_found")}</span>
    </div>
  );
}

export default PublicLoading;
